module.exports = __webpack_public_path__ + "img/质量标准select - 副本.367a46f8.svg";